import { render, staticRenderFns } from "./MyPetHome.vue?vue&type=template&id=0b85884a&"
import script from "./MyPetHome.vue?vue&type=script&lang=js&"
export * from "./MyPetHome.vue?vue&type=script&lang=js&"
import style0 from "./MyPetHome.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports